import { Link } from 'react-router-dom';
import { recommendedVideos } from '@/mocks/homeData';

const videoImages = [
  'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%2C%20warrior%20in%20traditional%20armor%20standing%20in%20misty%20palace%20courtyard%20at%20night%2C%20warm%20golden%20lantern%20light%2C%20cinematic%20mood%2C%20soft%20amber%20tones%2C%20clean%20minimal%20background%20with%20traditional%20architecture%20silhouette&width=600&height=800&seq=rec-video-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20style%2C%20astronaut%20floating%20in%20deep%20space%20with%20glowing%20galaxy%20behind%2C%20warm%20coral%20and%20golden%20nebula%20colors%2C%20cinematic%20lighting%2C%20clean%20dramatic%20composition%2C%20epic%20scale&width=600&height=800&seq=rec-video-02&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20poster%20with%20energetic%20group%20silhouettes%20against%20vibrant%20gradient%20background%2C%20warm%20amber%20and%20coral%20stage%20lights%2C%20festive%20entertainment%20mood%2C%20dynamic%20composition%2C%20clean%20poster%20design%20style&width=600&height=800&seq=rec-video-03&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20food%20documentary%20poster%20style%2C%20steaming%20bowl%20of%20noodles%20on%20rustic%20wooden%20table%2C%20warm%20golden%20natural%20light%2C%20earthy%20rich%20tones%2C%20intimate%20close-up%20shot%2C%20artistic%20food%20photography%20with%20soft%20steam&width=600&height=800&seq=rec-video-04&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Anime%20style%20fantasy%20poster%2C%20young%20warrior%20with%20glowing%20flame%20powers%20in%20epic%20battle%20pose%2C%20warm%20golden%20and%20amber%20energy%20effects%2C%20dramatic%20cinematic%20lighting%2C%20clean%20illustration%20style%20with%20detailed%20character%20design&width=600&height=800&seq=rec-video-05&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Elegant%20variety%20show%20poster%20with%20graceful%20female%20silhouettes%20on%20stage%2C%20soft%20warm%20spotlight%20in%20amber%20and%20rose%20tones%2C%20glamorous%20entertainment%20atmosphere%2C%20clean%20artistic%20composition%2C%20dreamy%20sparkle%20effects&width=600&height=800&seq=rec-video-06&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Modern%20Chinese%20drama%20poster%20style%2C%20business%20professional%20standing%20in%20contemporary%20cityscape%20at%20sunset%2C%20warm%20golden%20hour%20light%2C%20sophisticated%20mood%2C%20clean%20cinematic%20composition%2C%20urban%20skyline%20silhouette&width=600&height=800&seq=rec-video-07&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%20style%2C%20mythical%20young%20hero%20with%20flaming%20powers%20surrounded%20by%20ancient%20Chinese%20mythological%20elements%2C%20warm%20golden%20and%20coral%20energy%2C%20epic%20cinematic%20lighting%2C%20clean%20dramatic%20illustration&width=600&height=800&seq=rec-video-08&orientation=portrait',
];

export default function FeaturedVideos() {
  return (
    <section className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选好内容，等你来发现</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {recommendedVideos.map((video) => (
            <Link
              key={video.id}
              to={`/category/${video.category === '电视剧' ? 'drama' : video.category === '电影' ? 'movie' : video.category === '综艺' ? 'variety' : video.category === '纪录片' ? 'documentary' : video.category === '动漫' ? 'anime' : 'all'}`}
              className="group cursor-pointer"
            >
              {/* Card */}
              <div className="relative rounded-lg overflow-hidden bg-background-50">
                {/* Image */}
                <div className="relative w-full aspect-[3/4] overflow-hidden">
                  <img
                    src={videoImages[video.id - 1]}
                    alt={video.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    title={`豆花视频 - ${video.title}`}
                  />
                  {/* Badge */}
                  <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium rounded bg-accent-500 text-white">
                    {video.badge}
                  </span>
                  {/* Rating */}
                  <div className="absolute top-2 right-2 flex items-center gap-0.5 px-1.5 py-0.5 rounded bg-black/50 text-white text-xs">
                    <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                    {video.rating}
                  </div>
                  {/* Hover Overlay */}
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <i className="ri-play-fill text-xl text-primary-600"></i>
                    </div>
                  </div>
                </div>

                {/* Info */}
                <div className="p-3">
                  <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 mb-1">
                    {video.title}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-700 font-medium">
                      {video.category}
                    </span>
                    <span>{video.updateInfo}</span>
                  </div>
                  <p className="text-xs text-foreground-400 mt-1">
                    <i className="ri-eye-line mr-1"></i>
                    {video.views}次播放
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Mobile View All */}
        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
          >
            查看全部内容
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}